/**
 * Validates video duration
 * @param file
 * @param maxDuration in seconds
 * @returns {boolean} flag whether duration is valid or not
 */
export function validateVideoDuration(file: File, maxDuration: number): Promise<boolean> {
  const videoEl = document.createElement('video');

  return new Promise<boolean>((resolve, reject) => {
    videoEl.preload = 'metadata';

    videoEl.onloadedmetadata = () => {
      window.URL.revokeObjectURL(videoEl.src);

      if (Number.isNaN(videoEl.duration)) {
        reject();
      }

      resolve(videoEl.duration <= maxDuration);
    };

    videoEl.src = URL.createObjectURL(file);
  }).finally(() => {
    videoEl.remove();
  });
}
